import React from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
} from "@mui/material";
import styles from "./PriceTable.module.css";
import CheckSharpIcon from "@mui/icons-material/CheckSharp";
import { AppSumo_Tier_1, AppSumo_Tier_2 } from "./ListDetails";

const AppSumo = ({ planName }) => {
  const planList =
    planName === "AppSumo(Tier 1)" ? AppSumo_Tier_1 : AppSumo_Tier_2;

  return (
    <Box
      sx={{
        height: "100%",
        overflow: "scroll",
        position: 'absolute',
        width: "100%",
        overflowX:'hidden'
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          fontSize: "30px",
          fontweight: "bold",
          padding: "30px",
          color: " var(--header-color)",
        }}
      >
        {planName}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{
            display: "inline-block",
            width: "35%",
            margin: "0 1%",
            background: "#f5f5f5",
            borderRadius: "32px",
            padding: "38px 48px",
            verticalAlign: "top",
          }}
        >
          <List
            sx={{ width: "100%", maxWidth: 360, ":hover": "none" }}
            className={styles.list}
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            {planList.map((list, i) => {
              return (
                <ListItemButton className={styles.list_button} key={i}>
                  <Box className={styles.check_icon}>
                    <CheckSharpIcon fontSize="5px" color="primary" />
                  </Box>
                  <ListItemText className={styles.listed_text} primary={list} />
                </ListItemButton>
              );
            })}
          </List>
        </Box>
      </Box>
    </Box>
  );
};

export default AppSumo;
